// extracted by mini-css-extract-plugin
export default {"cupra":"LinkButton_cupra__TZ8VI","link":"LinkButton_link__ACqjc","icon":"LinkButton_icon__2Gs29"};